import { Typography } from '@remarkable/ark-web';

import { useAccountInfoSuspense } from 'src/api/queries';
import { Button, CardContent, Divider } from 'src/components';

import { Trans } from '@lingui/react/macro';
import { ChevronRight } from '@remarkable/ark-icons';
import { ConfirmUnlinkModal, useUnlinkIdentity } from './ConfirmUnlinkModal';

export const getAuthProviderDisplayName = (provider: string) => {
  switch (provider) {
    case 'google-oauth2':
      return 'Google';
    case 'facebook':
      return 'Facebook';
    case 'apple':
      return 'Apple';
    default:
      return provider;
  }
};

export const LinkedAccounts = () => {
  const accountInfo = useAccountInfoSuspense();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setIdentityToUnlink] = useUnlinkIdentity();

  if (!accountInfo.data?.identities) return null;

  const isAllIdentitiesSocial = accountInfo.data.identities.every(
    (identity) => identity.isSocial
  );
  const isNoneIdentitiesSocial = accountInfo.data.identities.every(
    (identity) => !identity.isSocial
  );

  // We only show the ui when there is a mix of social and non-social identities.
  // This is usually the case when a user logs in through a social login provider
  // after having already created a regular account with email and password, and
  // these two identities are automatically linked together by matching email addresses.
  if (isAllIdentitiesSocial || isNoneIdentitiesSocial) return null;

  return (
    <>
      <Divider />

      <Typography variant="heading-subtle-2xl" as="h2">
        <Trans>Social login</Trans>
      </Typography>

      {accountInfo.data.identities
        .filter((identity) => identity.isSocial)
        .map((identity) => (
          <CardContent key={identity.provider}>
            <div className="flex justify-between" data-cy="identity-card">
              <Typography variant="body-md">
                {getAuthProviderDisplayName(identity.provider)}
              </Typography>

              <ConfirmUnlinkModal>
                <Button
                  size="medium"
                  variant="tertiary-neutral"
                  onClick={() => {
                    setIdentityToUnlink({
                      id: identity.user_id,
                      provider: identity.provider,
                    });
                  }}
                >
                  <span>
                    <Trans>Remove</Trans>
                  </span>
                  <ChevronRight size={24} className="inline max-h-24" />
                </Button>
              </ConfirmUnlinkModal>
            </div>
          </CardContent>
        ))}
    </>
  );
};
